import type { DateRange } from '@/lib/date-presets'
import { getPresetRange } from '@/lib/date-presets'

/** Các kỳ có sẵn trong ô Thời gian của cột lọc báo cáo (theo KiotViet). */
export const REPORT_PRESETS = [
    'today',
    'yesterday',
    'this_week',
    '7d',
    '30d',
    'month',
    'quarter',
    'year',
] as const
export type ReportPreset = (typeof REPORT_PRESETS)[number]

/**
 * Phần chung của bộ lọc các trang báo cáo có cột lọc (nằm trên URL — gửi link
 * là mở đúng bộ lọc). `from`/`to` chỉ dùng khi `preset` là 'custom'.
 */
export interface ReportPeriodSearch {
    display: 'chart' | 'report'
    preset: ReportPreset | 'custom'
    from?: string
    to?: string
}

export const DEFAULT_PERIOD_SEARCH: ReportPeriodSearch = {
    display: 'report',
    preset: 'this_week',
}

const YMD = /^\d{4}-\d{2}-\d{2}$/

/** Đọc phần kỳ + kiểu hiển thị từ URL; giá trị lạ về mặc định. */
export function validatePeriodSearch(
    raw: Record<string, unknown>,
): ReportPeriodSearch {
    const preset = REPORT_PRESETS.find((p) => p === raw.preset)
    const isCustom =
        raw.preset === 'custom' &&
        typeof raw.from === 'string' &&
        YMD.test(raw.from) &&
        typeof raw.to === 'string' &&
        YMD.test(raw.to)
    return {
        display: raw.display === 'chart' ? 'chart' : 'report',
        preset: isCustom ? 'custom' : (preset ?? DEFAULT_PERIOD_SEARCH.preset),
        from: isCustom ? (raw.from as string) : undefined,
        to: isCustom ? (raw.to as string) : undefined,
    }
}

/** Khoảng ngày thực của bộ lọc; ngày đảo ngược thì đổi chỗ cho hợp lệ. */
export function resolvePeriodRange(search: ReportPeriodSearch): DateRange {
    if (search.preset === 'custom' && search.from && search.to) {
        return search.from <= search.to
            ? { from: search.from, to: search.to }
            : { from: search.to, to: search.from }
    }
    return getPresetRange(
        search.preset === 'custom'
            ? DEFAULT_PERIOD_SEARCH.preset
            : search.preset,
    )
}

/** Có đang lọc khác mặc định không (để hiện nút Xoá lọc). */
export function isPeriodFiltered(search: ReportPeriodSearch): boolean {
    return search.preset !== DEFAULT_PERIOD_SEARCH.preset
}
